module.exports = __webpack_public_path__ + "static/media/6.46d25552.JPG";